import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';
import {NavLink} from 'react-router-dom'
import {Button, Container, FormGroup, Input, Label, Col, Row} from 'reactstrap'
import Loading from 'apa/components/Loading';
import {formatDate} from 'invoices/containers/InvoiceDetail';
import { logout } from '../actions';

@connect(
    state => ({
        user: state.apa.user,
        errors: state.apa.errors,
        isAuthenticated: state.apa.isAuthenticated,
        isLoading: state.apa.isLoading
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Home extends Component {

    state = {
        code: '',
        username: '',
        password: '',
        repeatPassword: '',
        captcha: '',
        privacyAccepted: false,
    }

    constructor(props) {
        super(props);
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const {
            username,
            password
        } = this.state;
        this.props.login(username, password)
    }

    setPrivacyAccepted(event) {
        this.setState({
            privacyAccepted: event.target.checked
        })

    }

    componentDidMount(){
        window.onpopstate=(event)=>{
            if(event.type === "popstate"){
               window.location.reload()
            }
        }
    }

    render() {
        if(this.props.user.access_code?.status === 2 && this.props.user.access_code?.attempts === 0 || this.props.user.access_code?.status === 1 && this.props.user.access_code?.attempts === 0 || this.props.user.access_code?.status === 3) {
            return <Redirect to={'/training/status'} />
        }
        const year = new Date().getFullYear();
        const {user} = this.props

        if(this.props.user.is_superuser) {
            return (
              <Container><h1>Willkommen {this.props.user.username}</h1></Container>
            );
        }

        const start = (new Date(user.access_code.training?.start_at)).toLocaleDateString('de')
        const end = (new Date(user.access_code.training?.end_at)).toLocaleDateString('de')
        const name = user.access_code.training?.name

        if(this.props.isLoading)
            return <Loading/>;
        return (
            <Container>
                <h1>
                    Willkommen zur diesjährigen {year} Sicherheits-Unterweisung / Schulung
                </h1>
                <p>
                    Die für Sie bereitstehenden Unterweisungs- Präsentationen steht in dem vorgegebenen Zeitraum {start} - {end} jederzeit für Sie bereit. Nach Ablauf des genannten Datums wird der Zugang automatisch für Sie gesperrt.
                </p>
                <p className='alert alert-danger'>
                    Sollten Gründe wie z.B. Urlaubsaufenthalt, Krankheit etc. vorliegen, ist ein neues Zeitfenster für den betroffenen Teilnehmer durch den Verantwortlichen zu bestimmen.
                </p>
                <p>
                    Alternativ ist ein Termin zur persönlichen Unterweisung zu finden.
                </p>
                <h2>
                    Präsentation START:
                </h2>
                <p>
                Nach Starten der Präsentation können Sie jederzeit unterbrechen. (automatische Abmeldung nach 5 Min. Inaktivität) Bei erneuter Anmeldung starte die Präsentation neu.
                </p>
                <p>
                Sie können jederzeit und so oft sie wollen, in der Präsentation vor- bzw. zurückgehen.<br />Nehmen Sie sich Zeit! Niemand drängelt!

                </p>
                <h2>
                    Präsentation ENDE:
                </h2>
                <p>
                    Am Ende der Präsentation haben Sie folgende Möglichkeiten:
                </p>
                <ol>
                    <li>
                        Zurück zum Start - <span className='text-danger'>Präsentation startet erneut</span>
                    </li>
                    <li>
                        Weiter zur Wissenskontrolle - <span className='text-danger'>Es öffnet sich ein Fragenkatalog zur Wissenskontrolle.</span>
                    </li>
                </ol>
                <ul>
                    <li>
                        Nach dem Start der Wissenskontrolle ist diese bis zum Ende durchzuführen. (für den Zeitraum ist die Präsentation gesperrt)
                    </li>
                    <li>
                    Nach jeder Unterbrechung und jedem Neustart der Wissenskontrolle erstellt sich ein neuer Fragenkatalog.
                    </li>
                </ul>
                <h2>
                    Wissens- Verständniskontrolle: (Fragebogen)
                </h2>
                <p>
                    Am Ende der Wissens- Verständniskontrolle gibt es folgende Möglichkeiten:
                </p>
                <ol>
                    <li>
                        Super, Glückwunsch, Sie haben die notwendige Punktzahl erreicht! – (61 - 100 %)
                        <p className='text-danger'>
                            (für Teilnehmerzertifikat (Erfolgreich bestanden) bitte hier drücken)
                        </p>
                    </li>
                    <li>
                    Schade, da fehlten nur ein paar Punkte! (50 - 60 % erreicht) 3 zusätzliche Fragen stehen für Sie bereit.
                        <p className='text-danger'>
                            (für 2ten und/oder 3ten Versuch bitte hier drücken)
                        </p>
                    </li>
                    <li>
                        Upps, die zu erreichende Punktzahl ist nicht erreicht! – (0 - 49 %)
                        <p className='text-danger'>
                            (für neuen Fragebogen hier drücken)
                            <br/>
                            (zum Start der Präsentation bitte hier drücken)<br />
                            (für Teilnahmebestätigung bitte hier drücken)
                        </p>
                    </li>
                    <li>
                        Nach 3 vergeblichen Versuchen
                        <p className='text-danger'>
                            (für Teilnahmebestätigung bitte hier drücken)
                        </p>
                    </li>
                </ol>
                <p>
                    Nach erreichter Punktzahl und damit erfolgreichem Abschluss der Wissenskontrolle wird Ihr Zugang gesperrt.
                </p>
                <h2>
                    Fragen und/oder Kommentare
                </h2>
                <p>
                Sie haben Fragen, ein Anliegen, Anregungen, Verbesserungsvorschläge, Bedürfnisse? Dann schicken Sie eine E-Mail an unsere Fachkraft für Arbeitssicherheit und Brandschutz: <a href="mailto:info@sicher-arbeiten.hamburg">info@sicher-arbeiten.hamburg</a> und/oder wenden Sie sich auch gerne an Ihren direkten Vorgesetzten im Unternehmen.
                </p>
                <p className='text-danger'>
                    Die von Ihnen gesendete Mail wird nicht ohne Ihr ausdrückliches Einverständnis weitergegeben.
                </p>
                <p className='text-bold'>
                    Nach Starten der Präsentation können Sie jederzeit unterbrechen und starten nach erneuter Anmeldung bei der zuletzt von Ihnen gesehenen Präsentationsseite
                </p>
                <p>
                <div onChange={this.setPrivacyAccepted.bind(this)}>
                    <FormGroup>
                        <Label>
                            Ich stimme den <a href="https://sicher-arbeiten.hamburg/datenschutz" target="_blank">Datenschutzrichtlinien</a> zu
                            <Input type="checkbox" name="privacy" style={{marginLeft: 10, marginTop: 6}} />
                        </Label>
                    </FormGroup>
                </div>
                </p>
                <p className='text-center'>
                    <Button disabled={this.state.privacyAccepted !== true} color='primary' onClick={(e) => {
                                                                                e.preventDefault();
                                                                                window.location.href='/training/do';
                                                                                }}>Start der Präsentation</Button>
                </p>
                <p>
                    Wir wünschen viel Erfolg und freuen uns auf ein gemeinsames, unfallfreies und gesundes Jahr mit Ihnen.
                </p>
            </Container>
        )
    }
}

Home.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
